import { checkboxAnatomy as d } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as i, defineStyle as o } from "@chakra-ui/styled-system";
const { definePartsStyle: e, defineMultiStyleConfig: t } = i(d.keys), l = e(({ theme: r }) => ({
  container: {
    minHeight: r.filter.quickfilterHeight
  },
  label: {
    ...r.controlLargeLabel,
    color: r.text.default,
    paddingTop: r.controlLargeLabelPadding
  },
  control: {
    borderColor: r.interactive.default,
    borderStyle: r.borderStyle.default.style,
    borderRadius: r.checkboxBorderRadius,
    borderWidth: r.controlBorderWidth,
    height: r.controlIconLarge,
    width: r.controlIconLarge,
    _checked: {
      backgroundColor: r.interactive.backgroundSelected,
      borderColor: r.interactive.backgroundSelected,
      _hover: {
        backgroundColor: r.interactive.backgroundSelected,
        borderColor: r.interactive.backgroundSelected
      }
    }
  }
})), a = {
  outline: e(({ theme: r }) => ({
    container: o({
      transition: "border 0.2s ease",
      borderColor: r.borderStyle.default.color,
      borderStyle: r.borderStyle.default.style,
      borderRadius: r.filter.quickFilterBorderRadius,
      borderWidth: r.borderStyle.default.width,
      paddingLeft: r.element.spacingMedium,
      paddingRight: r.element.spacingMedium,
      _hover: {
        borderColor: r.borderStyle.emphasized.color,
        borderStyle: r.borderStyle.emphasized.style,
        borderWidth: r.borderStyle.emphasized.width
      }
    }),
    label: o({
      color: r.text.accent1
    })
  })),
  circular: e(({ theme: r }) => ({
    control: o({
      transition: "border 0.2s ease",
      size: r.shoppingListItemCompletionIndicatorIcon,
      borderColor: r.border.default,
      borderRadius: r.shoppingListItemCompletionIndicatorRadius,
      borderWidth: r.shoppingListItemBorder,
      paddingLeft: r.element.spacingMedium,
      paddingRight: r.element.spacingMedium,
      backgroundColor: r.interactive.backgroundDefault,
      _hover: {
        borderColor: r.border.hover
      },
      _checked: {
        backgroundColor: r.interactive.deemphasized,
        borderColor: r.interactive.deemphasized,
        _hover: {
          backgroundColor: r.interactive.deemphasized,
          borderColor: r.interactive.deemphasized
        }
      }
    })
  }))
}, b = t({
  baseStyle: l,
  variants: a,
  defaultProps: {
    size: null
  }
});
export {
  b as default
};
